import { useMemo } from "react";
import { useAppSelector } from "../../../store/store"
import { UserInfoType } from "../types";

export const useUserInfo = (): UserInfoType => {
    const userInfo = useAppSelector((store) => store?.authReducer?.userData);
    const data = useMemo(() => ({
        userId: userInfo.username,
        firstName: userInfo?.name,
        lastName: userInfo?.middle_name || "",
        phone: userInfo?.attributes?.phone_number || "",
        email: userInfo?.attributes?.email || "",
        tenantId: userInfo?.tenantId || "",
        tenantCode: userInfo?.tenantCode || "",
        role: userInfo?.group || "",
        timezone: userInfo?.timezone || ""
    }), [userInfo])
    return data;
}
